import { FormControl, FormErrorMessage, FormLabel, Input } from '@apollo/orbit';
import React, { ChangeEvent } from 'react';

interface Props {
  inputName: string;
  label: React.ReactNode | string;
  isInvalid: boolean;
  isDisabled: boolean;
  handleChange: (e: ChangeEvent) => void;
  placeholder?: string;
  value?: string;
  error?: string;
  autoFocus?: boolean;
  className?: string;
}

export function ChannelInput({
  inputName,
  label,
  isInvalid,
  isDisabled,
  handleChange,
  placeholder,
  value,
  error,
  autoFocus,
  className,
}: Props) {
  return (
    <FormControl isInvalid={isInvalid} className={className}>
      <FormLabel>{label}</FormLabel>
      <Input
        autoFocus={autoFocus}
        type="text"
        name={inputName}
        isDisabled={isDisabled}
        onChange={handleChange}
        placeholder={placeholder}
        value={value}
      />
      <FormErrorMessage>{error}</FormErrorMessage>
    </FormControl>
  );
}
